export default {
  type: 'qtrMetricsExceptions',
  name: 'Quarterly Completeness Exceptions',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    insert: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    update: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    delete: { app: 'metrics_dash', role: 'metrics_qtr_data' }
  },
  search: {
    search: 'allQtrMetricsExceptions',
    orderBy: {
      type: 'QtrMetricsExceptionsOrderBy',
      default: 'DATASTREAM_ASC'
    },
    fields: [
      {
        name: 'datastream',
        order: 'DATASTREAM'
      },
      {
        name: 'startDate',
        order: 'START_DATE',
        searchable: false
      },
      {
        name: 'endDate',
        order: 'END_DATE',
        searchable: false
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'datastream',
        required: true
      },
      {
        field: 'startDate',
        type: 'Date',
        required: true
      },
      {
        field: 'endDate',
        type: 'Date'
      }
    ],
    key: ['datastream', 'startDate'],
    input: 'qtrMetricsException',
    create: 'createQtrMetricsException',
    delete: 'deleteQtrMetricsException',
    update: 'updateQtrMetricsException'
  },
  load: {
    nodeId: 'qtrMetricsException',
    key: 'qtrMetricsExceptionByDatastreamAndStartDate'
  },
  form: {
    print: false,
    schema: [
      {
        name: 'datastream',
        required: true
      },
      {
        name: 'startDate',
        type: 'date',
        required: true
      },
      {
        name: 'endDate',
        type: 'date'
      }
    ]
  }
}
